// Shim re-export to preserve existing import path
// The plan command has been folderized under ./plan/
export { planCommand } from "./plan/index.js";
